import { resource } from "./resource";

const templates = resource("/onboarding/template");
const checklists = resource("/onboarding/checklist");

// ---- templates (admin): what onboarding means at this organisation ----
// `phase` is "onboarding" or "offboarding"; omitted returns both, which is
// what a settings screen listing everything wants.
export const getOnboardingTemplates = async (phase) =>
  await templates.get(phase ? `?phase=${phase}` : "");
export const getOnboardingTemplate = async (id) => await templates.get(`/${id}`);
export const createOnboardingTemplate = async (input = {}) => await templates.post("", input);
export const updateOnboardingTemplate = async (id, input = {}) => await templates.put(`/${id}`, input);

// ---- checklists: one person's copy of it ----
export const getMyChecklist = async () => await checklists.get("/self");
export const getChecklistFor = async (employeeId) => await checklists.get(`/employee/${employeeId}`);
export const getAllChecklistProgress = async (phase) =>
  await checklists.get(phase ? `?phase=${phase}` : "");
export const assignChecklist = async (employeeId, templateId) =>
  await checklists.post(`/${employeeId}`, templateId ? { templateId } : {});

// status: "done" | "waived" | "pending". A document item needs documentUrl;
// waiving needs a note and an admin.
export const updateChecklistItem = async (checklistId, itemId, input = {}) =>
  await checklists.put(`/${checklistId}/item/${itemId}`, input);

/**
 * A five-minute link to open an item's document. The stored URL points into a
 * private bucket and opens nothing; the server signs a read for whoever may
 * see the checklist.
 */
export const getChecklistDocumentUrl = async (checklistId, itemId) =>
  await checklists.get(`/${checklistId}/item/${itemId}/document`);
